import React, { useEffect, useState } from 'react';
import { CircularProgress, Box } from '@mui/material';
import { checkAuthStatus, getUsername } from '../services/auth';

const PORTAL_LOGIN_URL = 'https://visual.eigentrage.com/login';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verifyAuth = async () => {
      // Check if we have a username (from URL or localStorage)
      const username = getUsername();

      if (username) {
        // We have a username, verify with backend
        const authenticated = await checkAuthStatus();
        setIsAuthenticated(authenticated);
      } else {
        // No username from URL/localStorage - still check backend
        // (user may be logged in via portal_auth cookie)
        const authenticated = await checkAuthStatus();
        setIsAuthenticated(authenticated);
      }
      setLoading(false);
    };

    verifyAuth();
  }, []);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    // Redirect to portal login
    window.location.href = PORTAL_LOGIN_URL;
    return null;
  }

  return children;
};

export default ProtectedRoute;